var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bcx-all c-panel",style:(_setup.style)},_vm._l((_setup.panelGroups),function(groups,key){return _c(_setup.NotificationPanelItemGroups,{key:key,attrs:{"item-groups":groups}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }